// extracted by mini-css-extract-plugin
export default {"filtersAffixed":"index_filtersAffixed__OKgnD"};